import { Modal } from 'react-bootstrap';
import allImages from '../../../assets/images/allImages';
import { SendInvitation } from '../../Enterprise/BondAdmin/enterpriseList/SendInvitation';
import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';

export const BasicPopup = (props) => {
  const [showSendInvitePopup, setShowSendInvitePopup] = useState(false);
  // const navigate = useNavigate();
  // const authReducer = useSelector((state) => state.authReducer);

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => {
          props.onHide();
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          closeButton
          className="modal-header px-8 pt-8 pb-4"
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title className="mx-auto">
            <div className="fw-bolder">{props.popupTitle}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-8 py-0 modal-body send-invitation-model text-center">
          <img
            src={props.entityLogo ? props.entityLogo : allImages.avtar}
            className="img-fluid mb-4"
            style={{ height: '4rem' }}
            alt="entityLogo"
          />
          <p className="mb-4">{props.popupSubTitle}</p>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          <div className="mx-auto">
            {props?.type === 'mapping' ? (
              <></>
            ) : (
              <button
                type="button"
                className="customTable action-btn btn btn-primary btn-hover-color"
                style={{
                  marginRight: props.otherButtonText !== '' ? '0.75rem' : '0',
                }}
                onClick={() => {
                  props.onHide();
                  props.onConfirmStatus();
                }}
              >
                Okay
              </button>
            )}
            {props?.type === 'mapping' ? (
              <button
                type="button"
                className="customTable action-btn btn btn-primary btn-hover-color me-4"
                onClick={() => {
                  props.onHide();
                  window.location.href =
                    '/enterprise/enterprise-admin/dashboard';
                }}
              >
                Go to Dashboard
              </button>
            ) : (
              <></>
            )}
            <button
              type="button"
              className="customTable action-btn btn btn-primary btn-hover-color"
              style={{
                display: props.otherButtonText !== '' ? 'inline-block' : 'none',
              }}
              onClick={() => {
                props.onHide();
                setShowSendInvitePopup(true);
              }}
            >
              {props.otherButtonText}
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <SendInvitation
        show={showSendInvitePopup}
        onHide={() => setShowSendInvitePopup(false)}
        entityName={props.entityName}
        entityLogo={props.entityLogo}
        entityID={props.entityID}
      />
    </>
  );
};
